export default __webpack_public_path__ + "static/media/mhd_feat._tiakola_pololo.47131a38.mp3";